import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
import { useTheme } from '../../contexts/theme-context';
import { CheckCircle, XCircle, Clock, AlertCircle, MinusCircle, Loader2, Ban, ShieldCheck, CircleDot, } from 'lucide-react';
const variantConfigs = {
    active: {
        label: 'Active',
        icon: _jsx(CheckCircle, {}),
        solid: {
            bg: 'bg-success-100 dark:bg-success-900',
            text: 'text-success-700 dark:text-success-300',
            border: 'border-success-200 dark:border-success-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-success-600 dark:text-success-400',
            border: 'border-success-500 dark:border-success-500',
        },
        dot: 'bg-success-500',
    },
    inactive: {
        label: 'Inactive',
        icon: _jsx(XCircle, {}),
        solid: {
            bg: 'bg-gray-100 dark:bg-gray-700',
            text: 'text-gray-700 dark:text-gray-300',
            border: 'border-gray-200 dark:border-gray-600',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-gray-600 dark:text-gray-400',
            border: 'border-gray-400 dark:border-gray-500',
        },
        dot: 'bg-gray-400',
    },
    pending: {
        label: 'Pending',
        icon: _jsx(Clock, {}),
        solid: {
            bg: 'bg-warning-100 dark:bg-warning-900',
            text: 'text-warning-700 dark:text-warning-300',
            border: 'border-warning-200 dark:border-warning-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-warning-600 dark:text-warning-400',
            border: 'border-warning-500 dark:border-warning-500',
        },
        dot: 'bg-warning-500',
    },
    success: {
        label: 'Success',
        icon: _jsx(CheckCircle, {}),
        solid: {
            bg: 'bg-success-100 dark:bg-success-900',
            text: 'text-success-700 dark:text-success-300',
            border: 'border-success-200 dark:border-success-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-success-600 dark:text-success-400',
            border: 'border-success-500 dark:border-success-500',
        },
        dot: 'bg-success-500',
    },
    error: {
        label: 'Error',
        icon: _jsx(XCircle, {}),
        solid: {
            bg: 'bg-danger-100 dark:bg-danger-900',
            text: 'text-danger-700 dark:text-danger-300',
            border: 'border-danger-200 dark:border-danger-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-danger-600 dark:text-danger-400',
            border: 'border-danger-500 dark:border-danger-500',
        },
        dot: 'bg-danger-500',
    },
    warning: {
        label: 'Warning',
        icon: _jsx(AlertCircle, {}),
        solid: {
            bg: 'bg-warning-100 dark:bg-warning-900',
            text: 'text-warning-700 dark:text-warning-300',
            border: 'border-warning-200 dark:border-warning-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-warning-600 dark:text-warning-400',
            border: 'border-warning-500 dark:border-warning-500',
        },
        dot: 'bg-warning-500',
    },
    info: {
        label: 'Info',
        icon: _jsx(AlertCircle, {}),
        solid: {
            bg: 'bg-info-100 dark:bg-info-900',
            text: 'text-info-700 dark:text-info-300',
            border: 'border-info-200 dark:border-info-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-info-600 dark:text-info-400',
            border: 'border-info-500 dark:border-info-500',
        },
        dot: 'bg-info-500',
    },
    draft: {
        label: 'Draft',
        icon: _jsx(MinusCircle, {}),
        solid: {
            bg: 'bg-slate-100 dark:bg-slate-700',
            text: 'text-slate-700 dark:text-slate-300',
            border: 'border-slate-200 dark:border-slate-600',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-slate-600 dark:text-slate-400',
            border: 'border-slate-400 dark:border-slate-500',
        },
        dot: 'bg-slate-400',
    },
    processing: {
        label: 'Processing',
        icon: _jsx(Loader2, { className: "animate-spin" }),
        solid: {
            bg: 'bg-info-100 dark:bg-info-900',
            text: 'text-info-700 dark:text-info-300',
            border: 'border-info-200 dark:border-info-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-info-600 dark:text-info-400',
            border: 'border-info-500 dark:border-info-500',
        },
        dot: 'bg-info-500',
    },
    cancelled: {
        label: 'Cancelled',
        icon: _jsx(Ban, {}),
        solid: {
            bg: 'bg-gray-100 dark:bg-gray-700',
            text: 'text-gray-700 dark:text-gray-300',
            border: 'border-gray-200 dark:border-gray-600',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-gray-600 dark:text-gray-400',
            border: 'border-gray-400 dark:border-gray-500',
        },
        dot: 'bg-gray-400',
    },
    approved: {
        label: 'Approved',
        icon: _jsx(ShieldCheck, {}),
        solid: {
            bg: 'bg-success-100 dark:bg-success-900',
            text: 'text-success-700 dark:text-success-300',
            border: 'border-success-200 dark:border-success-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-success-600 dark:text-success-400',
            border: 'border-success-500 dark:border-success-500',
        },
        dot: 'bg-success-500',
    },
    completed: {
        label: 'Completed',
        icon: _jsx(CheckCircle, {}),
        solid: {
            bg: 'bg-success-100 dark:bg-success-900',
            text: 'text-success-700 dark:text-success-300',
            border: 'border-success-200 dark:border-success-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-success-600 dark:text-success-400',
            border: 'border-success-500 dark:border-success-500',
        },
        dot: 'bg-success-500',
    },
    rejected: {
        label: 'Rejected',
        icon: _jsx(XCircle, {}),
        solid: {
            bg: 'bg-danger-100 dark:bg-danger-900',
            text: 'text-danger-700 dark:text-danger-300',
            border: 'border-danger-200 dark:border-danger-800',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-danger-600 dark:text-danger-400',
            border: 'border-danger-500 dark:border-danger-500',
        },
        dot: 'bg-danger-500',
    },
    default: {
        label: 'Default',
        icon: _jsx(CircleDot, {}),
        solid: {
            bg: 'bg-gray-100 dark:bg-gray-700',
            text: 'text-gray-700 dark:text-gray-300',
            border: 'border-gray-200 dark:border-gray-600',
        },
        outlined: {
            bg: 'bg-transparent',
            text: 'text-gray-600 dark:text-gray-400',
            border: 'border-gray-400 dark:border-gray-500',
        },
        dot: 'bg-gray-400',
    },
};
export const StatusChip = ({ variant = 'default', label, size = 'sm', showIcon = true, icon, showDot = false, pill = true, outlined = false, animate = false, className, onClick, }) => {
    const { theme } = useTheme();
    const isCompact = theme?.layoutDensity === 'compact';
    const config = variantConfigs[variant];
    const displayLabel = label || config.label;
    const colorStyle = outlined ? config.outlined : config.solid;
    // Size classes
    const sizeClasses = {
        xs: isCompact ? 'h-4 px-1.5 text-[10px] gap-0.5' : 'h-5 px-2 text-xs gap-1',
        sm: isCompact ? 'h-5 px-2 text-xs gap-1' : 'h-6 px-2.5 text-xs gap-1',
        md: isCompact ? 'h-6 px-2.5 text-xs gap-1.5' : 'h-7 px-3 text-sm gap-1.5',
        lg: isCompact ? 'h-7 px-3 text-sm gap-1.5' : 'h-8 px-4 text-sm gap-2',
    };
    const iconSizeClasses = {
        xs: 'h-2.5 w-2.5',
        sm: 'h-3 w-3',
        md: 'h-3.5 w-3.5',
        lg: 'h-4 w-4',
    };
    const dotSizeClasses = {
        xs: 'h-1 w-1',
        sm: 'h-1.5 w-1.5',
        md: 'h-2 w-2',
        lg: 'h-2.5 w-2.5',
    };
    // Clone icon with proper size
    const renderIcon = () => {
        if (showDot) {
            return (_jsx("span", { className: cn('rounded-full flex-shrink-0', dotSizeClasses[size], config.dot, animate && 'animate-pulse') }));
        }
        if (!showIcon)
            return null;
        const iconElement = icon || config.icon;
        if (!iconElement)
            return null;
        return (_jsx("span", { className: cn('flex-shrink-0', iconSizeClasses[size]), children: React.isValidElement(iconElement)
                ? React.cloneElement(iconElement, {
                    className: cn(iconSizeClasses[size], iconElement.props.className),
                })
                : iconElement }));
    };
    const Component = onClick ? 'button' : 'span';
    return (_jsxs(Component, { onClick: onClick, className: cn('inline-flex items-center font-medium whitespace-nowrap border transition-colors', sizeClasses[size], colorStyle.bg, colorStyle.text, colorStyle.border, pill ? 'rounded-full' : 'rounded-md', onClick && 'cursor-pointer hover:opacity-80', animate && variant !== 'processing' && 'animate-pulse', className), children: [renderIcon(), _jsx("span", { children: displayLabel })] }));
};
StatusChip.displayName = 'StatusChip';
// Convenience components for common statuses
export const ActiveChip = (props) => (_jsx(StatusChip, { variant: "active", ...props }));
export const InactiveChip = (props) => (_jsx(StatusChip, { variant: "inactive", ...props }));
export const PendingChip = (props) => (_jsx(StatusChip, { variant: "pending", ...props }));
export const SuccessChip = (props) => (_jsx(StatusChip, { variant: "success", ...props }));
export const ErrorChip = (props) => (_jsx(StatusChip, { variant: "error", ...props }));
export const WarningChip = (props) => (_jsx(StatusChip, { variant: "warning", ...props }));
// Helper function to get status chip from boolean
export const getStatusChipFromBoolean = (isActive, activeLabel = 'Active', inactiveLabel = 'Inactive') => (_jsx(StatusChip, { variant: isActive ? 'active' : 'inactive', label: isActive ? activeLabel : inactiveLabel }));
